import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  TextField,
  Button,
  Box,
  IconButton,
  Select,
  MenuItem,
  FormControl
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import cancelModalStyles from './style';

const CancelPurchaseOrderModal = ({ open, onClose, onConfirm }) => {
  const [orderNumber, setOrderNumber] = useState('5');
  const [selectedReason, setSelectedReason] = useState('');
  const [otherReason, setOtherReason] = useState('');

  const reasonOptions = [
    'Select',
    'Wrong item ordered',
    'Supplier unavailable',
    'Budget constraints',
    'Change in requirements',
    'Other'
  ];

  const handleConfirm = () => {
    onConfirm({
      orderNumber,
      reason: selectedReason === 'Other' ? otherReason : selectedReason,
      otherReason
    });
    onClose();
  };

  const handleCancel = () => {
    setSelectedReason('');
    setOtherReason('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={cancelModalStyles.dialog}
    >
      <DialogContent sx={cancelModalStyles.content}>
        <Box sx={cancelModalStyles.header}>
          <Typography sx={cancelModalStyles.title}>
            Cancel Purchase Order
          </Typography>
          <IconButton onClick={onClose} sx={cancelModalStyles.closeButton}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={cancelModalStyles.body}>
          <Box sx={cancelModalStyles.field}>
            <Typography sx={cancelModalStyles.label}>
              Order Number
            </Typography>
            <TextField
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
              variant="outlined"
              fullWidth
              sx={cancelModalStyles.input}
            />
          </Box>
          <Box sx={cancelModalStyles.field}>
            <Typography sx={cancelModalStyles.label}>
              Select a Reason
            </Typography>
            <FormControl fullWidth>
              <Select
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
                sx={cancelModalStyles.select}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select a reason
                </MenuItem>
                {reasonOptions.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box sx={cancelModalStyles.field}>
            <Typography sx={cancelModalStyles.label}>
              Other Reason
            </Typography>
            <TextField
              value={otherReason}
              onChange={(e) => setOtherReason(e.target.value)}
              variant="outlined"
              fullWidth
              multiline
              rows={1}
              sx={cancelModalStyles.textarea}
            />
          </Box>
        </Box>

        <Box sx={cancelModalStyles.actions}>
          <Button
            onClick={handleCancel}
            sx={{ ...cancelModalStyles.button, ...cancelModalStyles.cancelButton }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            sx={{ ...cancelModalStyles.button, ...cancelModalStyles.confirmButton }}
          >
            Confirm
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CancelPurchaseOrderModal;